import SvjStore from '../../Stores/Svj'
export const isFreeSVJ = () => {
  return SvjStore.data?.isFree ?? true
}
